export default {
  default: {
    editors: {
      default:
        "w-1/2 flex-none hover:bg-white_to_black border p-5 border-admin_bordered border-opacity-30",
      full: "w-full flex-none hover:bg-white_to_black border p-5 border-admin_bordered border-opacity-30",
    },
    fields: {
      default:
        "w-1/2 flex-none border border-admin_bordered/30 hover:border-admin_bordered p-5",
      full: "w-full flex-none border border-admin_bordered/30 hover:border-admin_bordered p-5",
    },
    groups: {
      default: {
        root: "mb-1",
        panel:
          "w-full h-[50px] flex justify-between items-center cursor-pointer bg-admin_secondary/50 rounded p-4",
        panel_content:
          "w-full h-[30px] flex flex-row items-center justify-between",
        panel_title: "text-admin_text text-lg font-semibold mr-5",
        panel_description: "text-sm text-admin_text ml-auto",
        panel_arrow: "text-admin_text ml-2",
        panel_expand_icon: "w-6 h-6 text-admin_text",
        content: "flex flex-row flex-wrap text-admin_text",
      },
    },
  },
}
